import { render, staticRenderFns } from "./DxMachineryDatabase.vue?vue&type=template&id=79884ad7&"
import script from "./DxMachineryDatabase.vue?vue&type=script&lang=js&"
export * from "./DxMachineryDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports